export default __webpack_public_path__ + "media/images/logo-ee400fb24534ddf6fe88822ca0ddca78.svg";